import React from 'react';
import CheckboxDesc from '../../../Layout/CheckboxDesc';
import formatPhoneNumber from '../../../../utils/formatPhoneNumber';
import getAvatarColor from '../../../../utils/getAvatarColor';

const ClientListItem = ({ msg, idx, listAdder, selected_client_list, getClientData, checkClintAllValue, selectedClientId }) => {
  const isSelected = selectedClientId === msg.id;

  const stopEventBubbling = (obj, event) => {
    const target = event.target.id;
    event.preventDefault();
    if (
      target == 'clientListItemCheckBoxDiv' ||
      target == 'clientListItemCheckBox' ||
      target == 'clientCheckIcon' ||
      target == 'clientCheckButton'
    ) {
      event.stopPropagation();
    } else {
      getClientData(obj.id);
    }
  };

  const checkedClient = e => {
    if (msg.disabled) return;
    listAdder(msg.id);
    checkClintAllValue(e);
  };

  return (
    <li
      id={idx}
      key={`${msg.id}client_id${Math.floor(Math.random() * 1000)}`}
      style={msg?.disabled ? { opacity: '0.5', pointerEvents: 'none' } : { borderBottom: '0.5px solid #EBEBEB' }}
      className={`default-cursor clientAvatarLI ${isSelected ? 'selected' : ''}`}
      onClick={e => stopEventBubbling(msg, e)}
      onKeyDown={e => stopEventBubbling(msg, e)}
    >
      <div className="flex-col-center" id="clientListItemCheckBoxDiv">
        <CheckboxDesc
          checked={selected_client_list.includes(msg.id)}
          onclick={checkedClient}
          classProps="fs-13 transparent-important"
          checkButtonProps="m-left-21 m-top-4 transparent-important"
          checkBoxId="clientListItemCheckBox"
          checkBoxButtonId="clientCheckButton"
          checkBoxButtonIconId="clientCheckIcon"
        />
      </div>
      <UserIcon msg={msg} idx={idx} />
      <SmallMessage msg={msg} />
    </li>
    // END
  );
};
export default ClientListItem;

const SmallMessage = ({ msg }) => {
  const msgTrim = msg => {
    if (msg && msg.length > 30) {
      return `${msg.substr(0, 30)}...`;
    }
    return msg;
  };
  return (
    <div
      key={`smallmsg_${msg.chat_id}`}
      className="no-text-wrap flex-col-left align-left clientListItemInfo"
    >
      <p className="margin-0 clientListItemName">{msgTrim(msg.name)}</p>
      <p className="margin-0 clientListItemSecondary">
        {msg.pos_ref_num ? `POS: ${msg.pos_ref_num}` : 'No POS ID'}
      </p>
      <p className="margin-0 clientListItemSecondary">
        {msg?.contactMethod === 'EMAIL'
          ? msg?.email || 'No Primary Contact Info'
          : formatPhoneNumber(msg?.mobile, 'b') || 'No Primary Contact Info'}
      </p>
    </div>
  );
};

const UserIcon = ({ msg, idx }) => {
  const initialFunc = name => {
    const initials = `${name}`
      .split(' ')
      .map(e => e.charAt(0))
      .slice(0, 2)
      .join('');
    return initials;
  };

  const avatarColor = getAvatarColor(msg.name);

  return (
    <div
      style={{ width: 'auto', alignItems: 'center', marginLeft: '8px' }}
      key={`${idx}_user_icon_${msg.chat_id}`}
      className="flex-row-nospacebetween-nowrap"
    >
      <div
        style={{
          background: avatarColor.bg,
          color: '#FFF',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
        className="clientAvatarInitials"
      >
        <span className="clientAvatarInitialsText">
          {initialFunc(msg.name)}
        </span>
      </div>
    </div>
  );
};
